module.exports = __webpack_public_path__ + "img/Daniel.2577a8ca.jpg";